// extracted by mini-css-extract-plugin
module.exports = {"row":"CartSubtotal_row__Nt1gY","label":"CartSubtotal_label__5fNAE","amount":"CartSubtotal_amount__lLlaG"};